import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, catchError, map, of, tap, distinctUntilChanged } from 'rxjs';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

interface MainRolesResponse {
  roles: string[];
  projetos: number[];
}

@Injectable({ providedIn: 'root' })
export class RolesService {
  private readonly rolesSubject = new BehaviorSubject<Set<string>>(new Set());
  readonly roles$ = this.rolesSubject.asObservable();
  readonly loaded$ = this.roles$.pipe(map(s => s.size > 0), distinctUntilChanged());

  constructor(private http: HttpClient) {}

  /** Chame isto no APP_INITIALIZER com o SSB (employeeId) */
  async loadAtStartup(ssb: string): Promise<void> {
    const headers = new HttpHeaders({ 'X-Correlation-ID': crypto?.randomUUID?.() ?? String(Date.now()) });

    const url = `${environment.apiUrl}Roles/${encodeURIComponent(ssb)}/main-roles`;

    await lastValueFrom(
      this.http.get<MainRolesResponse | MainRolesResponse[]>(url, { headers }).pipe(
        map((resp) => {
          // normaliza para array
          const list = Array.isArray(resp) ? resp : [resp];
          const roles = list.flatMap(x => Array.isArray(x?.roles) ? x.roles : []);
          // normaliza strings
          return new Set(roles.map(r => String(r).trim()));
        }),
        tap(set => {
          console.log('[roles] carregadas:', Array.from(set)); // <-- útil para conferir no console
          this.rolesSubject.next(set);
        }),
        catchError(err => {
          console.error('[roles] erro ao carregar', err);
          this.rolesSubject.next(new Set());
          return of(new Set<string>());
        })
      )
    );
  }

  hasRole(role: string): boolean {
    const want = String(role).toLowerCase();
    for (const r of this.rolesSubject.value) {
      if (String(r).toLowerCase() === want) return true;
    }
    return false;
  }

  hasRole$(role: string) {
    const want = String(role).toLowerCase();
    return this.roles$.pipe(map(set => {
      for (const r of set) if (String(r).toLowerCase() === want) return true;
      return false;
    }));
  }
}
